<template>
  <div class="container col dashboard">
    <section class="col s12 m12 l8 dashboard-main m-auto">
      <!-- jobs -->
      <div class="flex justify-between items-center dashboard-main mb-32 m-8 mt-24 xl:mt-0">
        <div>
          <div class="animate-pulse bg-grey-divider-subdued w-128 h-24 md:w-200px md:h-40px sm-vertical-spacing" />
          <div class="animate-pulse bg-grey-divider-subdued w-96 h-12 md:w-150px md:h-20px sm-vertical-spacing" />
        </div>
        <div class="animate-pulse bg-grey-divider-subdued w-96px h-96px rounded-full sm-vertical-spacing pl-8" />
      </div>
      <div class="md-vertical-spacing">
        <div class="animate-pulse bg-grey-divider-subdued w-160px h-20px sm-vertical-spacing" />
        <div class="animate-pulse bg-grey-divider-subdued w-11/12 h-15px sm-vertical-spacing" />
      </div>

      <!-- sitter cards -->
      <div class="md-vertical-spacing inline-flex">
        <div class="mr-16 animate-pulse bg-grey-divider-subdued mr-8 w-120px lg:w-155px h-163px sm-vertical-spacing" />
        <div class="mr-16 animate-pulse bg-grey-divider-subdued mr-8 w-120px lg:w-155px h-163px sm-vertical-spacing" />
        <div class="mr-16 animate-pulse bg-grey-divider-subdued mr-8 w-120px lg:w-155px h-163px sm-vertical-spacing" />
        <div class="mr-16 animate-pulse bg-grey-divider-subdued mr-8 w-120px lg:w-155px h-163px sm-vertical-spacing" />
      </div>

      <!-- trust and safety -->
      <div class="mega-vertical-spacing">
        <div class="animate-pulse bg-grey-divider-subdued w-150px h-20px sm-vertical-spacing" />
        <div class="animate-pulse bg-grey-divider-subdued w-11/12 h-110px sm-vertical-spacing" />
      </div>

      <div class="animate-pulse bg-grey-divider-subdued w-3/5 h-20px sm-vertical-spacing" />
      <div class="animate-pulse bg-grey-divider-subdued w-full h-20px sm-vertical-spacing" />

      <!-- care type carousel -->
      <div class="lg-vertical-spacing flex">
        <div class="dashboard-job-carousel__clip">
          <div class="dashboard-job-carousel__box">
            <ul class="dashboard-job-carousel__main">
              <li>
                <div class="animate-pulse bg-grey-divider-subdued mr-1 w-120px lg:w-165px h-163px sm-vertical-spacing" />
              </li>
              <li>
                <div class="animate-pulse bg-grey-divider-subdued mr-1 w-120px lg:w-165px h-163px sm-vertical-spacing" />
              </li>
              <li>
                <div class="animate-pulse bg-grey-divider-subdued mr-1 w-120px lg:w-165px h-163px sm-vertical-spacing" />
              </li>
              <li>
                <div class="animate-pulse bg-grey-divider-subdued mr-1 w-120px lg:w-165px h-163px sm-vertical-spacing" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
export default {
  name: 'DashboardLoadingSkeleton',
};
</script>
